(function() {  
  function updateQuantityField(e, value) {
    var $qtyContainer = $(e.currentTarget).closest('.form-fields--qty');
    var $qtySelect = $qtyContainer.find('.form-field--qty-select');
    var $qtyInput = $qtyContainer.find('.form-field--qty-input');
    
    var over100 = value >= 100;
    
    if (!over100) {
      $qtySelect.find('.form-field-select').val(value);
      $qtySelect.find('.form-field-input').val(value);
    }
    
    $qtySelect[over100 ? 'addClass' : 'removeClass']('hidden');
    $qtySelect[over100 ? 'removeClass' : 'addClass']('visible');
    
    $qtyInput[!over100 ? 'addClass' : 'removeClass']('hidden');
    $qtyInput[!over100 ? 'removeClass' : 'addClass']('visible');    
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    console.log('READY');
    
    $(document).on('change', '.form-field-select', function(e) {
      //console.log(e);
      var value = $(e.currentTarget).val();
      updateQuantityField(e, value);
    });
    
    $(document).on('change', '.form-field-input', function(e) {
      //console.log(e);
      var value = $(e.currentTarget).val();
      updateQuantityField(e, value);
    });    
  });
})();